declare namespace $ {

	type $mol_view__sub_bog_ui_app_breadcrumb_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_breadcrumb_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_breadcrumb__crumbs_bog_ui_app_breadcrumb_3 = $mol_type_enforce<
		ReturnType< $bog_ui_app_breadcrumb['short_crumbs'] >
		,
		ReturnType< $bog_ui_breadcrumb['crumbs'] >
	>
	type $mol_view__sub_bog_ui_app_breadcrumb_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_breadcrumb__crumbs_bog_ui_app_breadcrumb_5 = $mol_type_enforce<
		ReturnType< $bog_ui_app_breadcrumb['long_crumbs'] >
		,
		ReturnType< $bog_ui_breadcrumb['crumbs'] >
	>
	export class $bog_ui_app_breadcrumb extends $mol_page {
		description( ): string
		Description( ): $mol_view
		short_title( ): string
		Short_title( ): $mol_view
		short_crumbs( ): readonly(any)[]
		Short( ): $bog_ui_breadcrumb
		long_title( ): string
		Long_title( ): $mol_view
		long_crumbs( ): readonly(any)[]
		Long( ): $bog_ui_breadcrumb
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=breadcrumb.view.tree.d.ts.map